export default __webpack_public_path__ + "static/media/gallery_03.ea039ddd.jpg";